import React from 'react';
import PropTypes from 'prop-types';

export default class BaseSetup extends React.Component {
  constructor() {
    super();
    this.unblockHistory = null;
  }

  componentWillUnmount() {
    this.enableHistoryPush();
  }

  enableHistoryPush() {
    if (this.unblockHistory) {
      this.unblockHistory();
      this.unblockHistory = null;
    }
  }

  push(path) {
    this.enableHistoryPush();
    this.props.history.push(path);
  }
}

BaseSetup.propTypes = {
  history: PropTypes.shape({
    block: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }),
};

BaseSetup.defaultProps = {
  history: {
    block: () => {},
    push: () => {},
  },
};
